/** Familia de un evento de uso. Espejo de `UxEventType` del backend: el servidor descarta cualquier otro. */
export type TelemetryEventType =
    | 'route' | 'click' | 'api' | 'dialog' | 'toast' | 'error'
    | 'flow' | 'visibility' | 'session' | 'assistant';

export type TelemetryProps = Record<string, string | number | boolean | null | (string | number | boolean)[]>;

/** Lo que se registra; `seq` y `ts` los pone el servicio. */
export interface TelemetryEventInput {
    type: TelemetryEventType;
    name: string;
    route?: string;
    routeParams?: Record<string, string>;
    props?: TelemetryProps;
    durationMs?: number;
    actor?: 'user' | 'assistant';
    flowId?: string;
    traceId?: string;
}

export interface TelemetryEvent extends TelemetryEventInput {
    seq: number;
    ts: number;
}

/** El cuerpo de `/telemetry/track`. Nada aquí dice quién es el usuario: eso lo saca el servidor del token. */
export interface TelemetryBatch {
    sessionId: string;
    anonId?: string;
    startedAt?: number;
    entryRoute?: string;
    appVersion?: string;
    userAgent?: string;
    viewport?: string;
    events: TelemetryEvent[];
}

export const TELEMETRY_LIMITS = {
    /** Cada cuánto se vacía la cola. */
    flushIntervalMs: 5_000,
    /** Con tantos eventos en cola se vacía sin esperar al intervalo. El servidor acepta hasta 100. */
    maxBatch: 40,
    /** Tope de la cola si el backend no contesta: se pierden los más viejos, nunca la pestaña. */
    maxQueue: 500,
    /** Sin teclado ni puntero durante esto, el tiempo deja de contar como activo. */
    idleAfterMs: 60_000,
    /** Sin actividad durante esto, la siguiente acción abre una sesión nueva. */
    sessionIdleMs: 30 * 60_000,
    /** Si un envío falla, el siguiente espera el doble, hasta este techo. */
    maxBackoffMs: 60_000,
    /** Errores por página cargada: un bucle que lanza no puede llenar la cola. */
    maxErrorsPerPage: 30,
} as const;
